import { render, staticRenderFns } from "./Similarity.vue?vue&type=template&id=27a3a473"
import script from "./Similarity.vue?vue&type=script&lang=js"
export * from "./Similarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports